import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Icon from '@/components/icon'

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(Icon)`
  cursor: pointer;
`

type Props = {
  onClick: () => void
  disabled?: boolean
}

const InfoIcon: React.FC<Props> = ({ onClick, disabled }) => {
  const { t } = useTranslation()
  return (
    <Button
      disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      type="button"
      onClick={onClick}
      aria-label={t('l.application.view.learn_more.button', 'Learn more')}
      title={t('l.application.view.learn_more.button', 'Learn more')}
    >
      <StyledIcon width={17} height={17} id="question_mark" />
    </Button>
  )
}

export default InfoIcon
